import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";

import { IntegrationsAzureUsedByTableCellProps } from "./types";

const IntegrationsAzureUsedByTableSpaceCell = ({
  item: stack,
  ...cellProps
}: IntegrationsAzureUsedByTableCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={stack.spaceDetails.id} fallbackName={stack.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default IntegrationsAzureUsedByTableSpaceCell;
